module.exports = __webpack_public_path__ + "static/media/activity.398de925.svg";